import Vue from 'vue';
import Vuex from 'vuex';
import fastQuoteModule from './modules/fastquote';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAnE1Q6058-GTlc9tK4cmbGX0EvqvflM8U",
  authDomain: "dash-waste-usa.firebaseapp.com",
  projectId: "dash-waste-usa",
  storageBucket: "dash-waste-usa.appspot.com",
  messagingSenderId: "537916132916",
  appId: "1:537916132916:web:9dca4451ea145366f10461",
  measurementId: "G-LWSFB7HR2B"
};

initializeApp(firebaseConfig);

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    fastQuote: fastQuoteModule
  }
});
export default store;